import { createSelector } from '@ngrx/store';
import { getDragonflySharedState } from '../../reducers';

export const getLiteralsState = createSelector(getDragonflySharedState, (state) => state.literals);

export const getUserSearch = createSelector(getLiteralsState, ({ literals }) => literals['liquid.user.tabs.search']);

export const getUserSecurityGroups = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.user.tabs.sequritygroups'],
);

export const getUserPolicyDocs = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.user.tabs.policydocs'],
);

export const getUserUserGroups = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.user.tabs.usergroups'],
);

export const getUserUserName = createSelector(getLiteralsState, ({ literals }) => literals['liquid.user.username']);

export const getUserDisplayedName = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.user.displayedname'],
);

export const getUserEmail = createSelector(getLiteralsState, ({ literals }) => literals['liquid.user.email']);

export const getUserSecurityGroup = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.user.securitygroup'],
);

export const getUserBusinessGroup = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.user.businessgroup'],
);

export const getDeactivated = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.user.usersearch.filters.deactivated'],
);

export const getQuicksight = createSelector(getLiteralsState, ({ literals }) => literals['liquid.user.isquicksight']);

export const getCreateNewUser = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.user.createnew.modal.header'],
);

export const getUpdateUser = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.user.update.modal.header'],
);

export const getUserName = createSelector(getLiteralsState, ({ literals }) => literals['liquid.user.username']);

export const getNewUserPasswd = createSelector(getLiteralsState, ({ literals }) => literals['liquid.user.newpassword']);

export const getLanguage = createSelector(getLiteralsState, ({ literals }) => literals['liquid.user.language']);

export const getCountries = createSelector(getLiteralsState, ({ literals }) => literals['liquid.user.countries']);

export const getSecuritygroupTooltip = createSelector(
  getLiteralsState,
  ({ literals }) => literals['createnew.securitygroup'],
);

export const getBusinessgroupTooltip = createSelector(
  getLiteralsState,
  ({ literals }) => literals['help.useradmin.createupdate.businessgroup'],
);

export const getUserCode = createSelector(getLiteralsState, ({ literals }) => literals['liquid.user.code']);

export const getDeleteFlag = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.checkbook.grouptemplate.filters.deleteflag'],
);

export const getUserDetailsUpdateSuccess = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.member.success.update'],
);

export const getUserDetailsCreateSuccess = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.member.success.create'],
);

export const getUserDeactivationSuccess = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.member.success.deactivation'],
);

export const getUserActivationSuccess = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.member.success.activation'],
);

export const getEditPolicy = createSelector(getLiteralsState, ({ literals }) => literals['liquid.policydoc.edit']);

export const getRolesInDocument = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.user.policydocs.rolesindoc'],
);

export const getAddRolesInDocument = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.user.policydocs.addrolesindoc'],
);

export const getAddPolicyDocInGroup = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.user.sequritygroups.addpolicydocingroup'],
);

export const getPolicyDocInGroup = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.user.sequritygroups.policydocingroup'],
);

export const getAddUserInGroup = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.user.businnessgroup.adduseringroup'],
);

export const getUsersInGroup = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.user.businnessgroup.usersingroup'],
);

export const getName = createSelector(getLiteralsState, ({ literals }) => literals['liquid.policydoc.name']);

export const getDescription = createSelector(getLiteralsState, ({ literals }) => literals['liquid.policydoc.notes']);

export const getEditSecGroup = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.securitygroup.edit'],
);

export const getCreateNewPolicyGroup = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.policydoc.new'],
);

export const getCreateNewSecurityGroup = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.securitygroup.new'],
);
